import { BeachAccess } from '@mui/icons-material'
import { TableCell, Tooltip } from '@mui/material'
import Holidays from 'date-holidays'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Day } from '../../../store/types'
import DateFormat from '../../../store/types/enums/DateFormat'
import { WorkHoursEmployeeMonthlySummaryDTO } from '../../../store/types/utils/WorklogTypes'
import { getHolidayNamesString } from '../../../store/utils/holidaysUtils'
import { stickyStyles, StyledEmployeeMonthlyHoursTableRow } from '../../../styles/EmployeeMonthlyHoursTableStyles'

type EmployeeMonthlyHoursTableRowProps = {
  day: Day
  employeesMonthlySummary: WorkHoursEmployeeMonthlySummaryDTO[]
}

const EmployeeMonthlyHoursTableRow = ({ day, employeesMonthlySummary }: EmployeeMonthlyHoursTableRowProps) => {
  const { i18n } = useTranslation()
  const hd = new Holidays('PL', '', '', { types: ['public'] })
  const holiday = hd.isHoliday(day.date.toDate())

  const getCellContent = useCallback(
    (employeeSummary: WorkHoursEmployeeMonthlySummaryDTO): JSX.Element | string => {
      const dayData = employeeSummary.days.find(d => d.date === day.date.format(DateFormat.YearMonthDay))
      if (!dayData) return '-'
      if (dayData.vacationMoreThanOthers) {
        return <BeachAccess sx={{ width: 16, height: 16, verticalAlign: 'middle' }} />
      }

      return dayData.totalHours ? dayData.totalHours.toString() : '-'
    },
    [day.date]
  )

  const getRowStyles = () => {
    if (holiday && !day.isWeekDay) return 'holiday-weekend'
    if (holiday) return 'holiday'
    if (!day.isWeekDay) return ' weekend'
    return ''
  }

  return (
    <StyledEmployeeMonthlyHoursTableRow key={day.id} className={getRowStyles()}>
      <Tooltip title={holiday ? getHolidayNamesString(holiday) : ''}>
        <TableCell
          sx={{
            ...stickyStyles,
            textWrap: 'nowrap',
            left: 0,
            color: holiday ? 'accent.orange.text' : 'text.base',
            fontWeight: 500,
            p: 2,
          }}
        >
          {day.date.locale(i18n.language).format(DateFormat.DayNumberDayName)}
        </TableCell>
      </Tooltip>
      {employeesMonthlySummary.map(emp => (
        <TableCell key={emp.employee.id} align="center" sx={{ p: 1 }} className={getRowStyles()}>
          {getCellContent(emp)}
        </TableCell>
      ))}
    </StyledEmployeeMonthlyHoursTableRow>
  )
}

export default EmployeeMonthlyHoursTableRow
